import SettingsPage from "./SettingsPage";
import { PageConfigTypes } from "app/types/PageTypes";
import { ROLES } from "../../constants/roles";
import ResetPassword from "./ResetPassword";

const SettingsPageConfig: PageConfigTypes = {
  baseRoute: {
    path: "/settings",
    exact: true,
    component: SettingsPage,
  },
  subRoutes: [
    {
      path: "/settings/reset-password",
      component: ResetPassword,
      authorities: [ROLES.ROLE_AGENT,ROLES.ROLE_SUB_AGENT],
    },
  ],
  settings: {
    navbar: {
      open: true,
      title: "app.main.sidebar.settings.title",
      subtitle: "app.main.sidebar.settings.desc",
      items: [
        {
          primaryText: "app.main.settings.reset-password.pageHeader.title",
          exact: true,
          to: "/reset-password",
          icon: "list",
        },
      ],
    },
  },
};

export default SettingsPageConfig;
